import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import { ModalState } from 'tradera/components/bank-id/state/bank-id/modal-state';
import { BankIdError } from './bank-id-error-message';

type BankIdModalBodyProps = {
    modalState: ModalState;
    errorCode?: string | null;
    qrData?: string | null;
};

export const BankIdModalBody = ({
    modalState,
    errorCode,
    qrData
}: BankIdModalBodyProps) => {
    const { t } = useTranslator();

    switch (modalState) {
        case ModalState.IN_PROGRESS:
            return (
                <>
                    <h1 className="heading-berlin text-styled mt-3">
                        {t('bankIdModal_InProgressTitle')}
                    </h1>
                    <p>{t('bankIdModal_InProgressText')}</p>
                    <div className="my-4">
                        {qrData && (
                            <img
                                src={`data:image/png;base64, ${qrData}`}
                                style={{ width: '300px' }}
                                alt=""
                            />
                        )}
                    </div>
                </>
            );
        case ModalState.ERROR:
            return (
                <>
                    <h1 className="heading-berlin text-styled mt-3">
                        {t('bankIdModal_ErrorTitle')}
                    </h1>
                    <BankIdError errorCode={errorCode} />
                </>
            );
        default:
            return null;
    }
};
